import { useSelector } from '@tmapy/redux';
export function useLocation() {
    return useSelector((state) => state.router);
}
//# sourceMappingURL=useLocation.js.map